import React from 'react';

const ACTIVATED_TAB_STYLE = {
  backgroundColor: 'transparent',
  color: '#FFFFFF',
  border: 'none',
  fontWeight: 'bold',
};

const DEFAULT_TAB_STYLE = {
  backgroundColor: 'transparent',
  color: '#FAFAFA80',
  border: 'none',
};

const HEADER_TABS = ['Program', 'Grading', 'Minutage'];

function SchedulerHeaderTabs({ activatedTab, onTabChange }) {
  return (
    <div>
      {HEADER_TABS.map((tab) => (
        <button
          key={tab}
          type="button"
          className="btn"
          style={tab === activatedTab ? ACTIVATED_TAB_STYLE : DEFAULT_TAB_STYLE}
          onClick={() => onTabChange(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}

export default SchedulerHeaderTabs;
